"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var Node_1 = __importDefault(require("./Node"));

var Compliment =
/** @class */
function (_super) {
  __extends(Compliment, _super);

  function Compliment() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Compliment.prototype.parse = function () {
    this.tokenizer.checkNextAndPop("compliment");
  };

  Compliment.prototype.typeCheck = function () {// nothing to check
  };

  Compliment.prototype.evaluate = function () {
    return this.param.compliment();
  };

  Compliment.prototype.setParam = function (colourChisel) {
    this.param = colourChisel;
  };

  return Compliment;
}(Node_1["default"]);

exports["default"] = Compliment;